import { useForm } from "react-hook-form";
import LabelTextArea from "../../../../../shared/components/labelTextArea";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import SpOtherMapper from "../mappers/spOtherMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";

const SpOther = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpOtherMapper.get(),
  });

  const navigate = useNavigate();

  const onSubmit = (data) => {
    SpOtherMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-30">Other</h1>
        <LabelTextArea
          id="otherDetails"
          label="Please provide details of the change"
          placeholder="Enter details"
          register={register("otherDetails", {
            required: "Comments are required",
          })}
          errors={errors.otherDetails}
          watch={watch("otherDetails")}
          trigger={trigger}
          maxLength={500}
        />

        <NewDateTimePicker
          name="otherEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.otherEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("otherEffectiveDateTime")}
          minDate={new Date()}
        />
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpOther;
